const styles = {
  content: {
    padding: "3em",
  },
  textFieldContainer: {
    width: "50%",
    padding: "0 1%",
    marginBottom: "1em",
  },
  textField: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  button: {
    marginTop: "2%",
    textAlign: "center",
  },
  textArea: {
    width: "205%",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "0.5em",
    paddingTop: "1em",
    marginLeft: "1em",
  },
};

export default styles;
